import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-calendar-days",
  templateUrl: "./med-icon-calendar-days.component.html",
})
export class MedIconCalendarDaysComponent extends SvgMixinComponent {}
